import React from 'react';
import Image from 'next/image';
import { TasticProps } from '../../types';

interface Image {
  url: string;
}

interface Dealer {
  id: string;
  longitude: number | null;
  latitude: number | null;
  website: string | null;
  country: string | null;
  city: string | null;
  zipCode: string | null;
  houseNumber: string | null;
  street: string | null;
  phoneNumber: string | null;
  email: string | null;
  name: string | null;
  groups: string[];
  image: Image | null;
}
interface DealerData {
  dataSourceId: string;
  dataSource: {
    language: string;
    results: Dealer[];
    facets: object[];
  };
}

const OcctooDealerList = ({ data }: TasticProps<{ dealers: DealerData }>) => {
  if (!data?.dealers?.dataSource?.results) return null;

  const dealers = data?.dealers?.dataSource?.results || [];

  return (
    <div className="mx-auto flex w-4/5 flex-col items-center text-center">
      <div className="grid grid-cols-1 gap-16 sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4">
        {dealers.map((dealer: Dealer) => (
          <div key={dealer?.id} className="mb-6 flex w-full flex-col rounded-xl p-12 shadow-lg">
            {dealer?.image?.url ? (
              <img
                src={dealer?.image?.url}
                alt={dealer?.name || 'Dealer Image'}
                className="aspect-1 h-full w-full rounded-xl object-cover pb-4"
              />
            ) : (
              <div className="mb-4 flex h-40 w-full items-center justify-center rounded-md bg-gray-200">
                No Image Available
              </div>
            )}
            <div className="flex flex-col">
              <div className="w-full text-left text-2xl">{dealer?.name || 'Unnamed Dealer'}</div>
            </div>
            <div>
              <div className="text-end">
                {dealer?.street} {dealer?.houseNumber}
              </div>
              <div className="text-end">
                {dealer?.zipCode} {dealer?.city}
              </div>
              <div className="text-end">{dealer?.phoneNumber}</div>
              <div className="mt-4 flex flex-row justify-end gap-4">
                {dealer?.email ? (
                  <a href={`mailto:${dealer.email}`} className="text-blue-600 underline">
                    <svg
                      stroke="currentColor"
                      fill="none"
                      strokeWidth="2"
                      viewBox="0 0 24 24"
                      aria-hidden="true"
                      height="32"
                      width="32"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"
                      ></path>
                    </svg>
                  </a>
                ) : null}
                {dealer?.website ? (
                  <a
                    href={dealer.website}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-blue-600 underline"
                  >
                    <svg
                      stroke="currentColor"
                      fill="none"
                      strokeWidth="2"
                      viewBox="0 0 24 24"
                      aria-hidden="true"
                      height="32"
                      width="32"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        d="M3.055 11H5a2 2 0 012 2v1a2 2 0 002 2 2 2 0 012 2v2.945M8 3.935V5.5A2.5 2.5 0 0010.5 8h.5a2 2 0 012 2 2 2 0 104 0 2 2 0 012-2h1.064M15 20.488V18a2 2 0 012-2h3.064M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                      ></path>
                    </svg>
                  </a>
                ) : null}{' '}
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default OcctooDealerList;
